var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useEffect, useRef } from 'react';
import { useInfiniteQuery, useMutation, useQuery, useQueryClient, } from '@tanstack/react-query';
import uuid from 'react-native-uuid';
import { GeneralActions } from '../../redux';
import { useDispatch } from 'react-redux';
export var InvalidationTag;
(function (InvalidationTag) {
    InvalidationTag["Person"] = "person";
    InvalidationTag["Countries"] = "countries";
    InvalidationTag["Ingredients"] = "ingredients";
    InvalidationTag["Customer"] = "customer";
    InvalidationTag["Code"] = "code";
    InvalidationTag["Activity"] = "activity";
    InvalidationTag["FeaturedContents"] = "featuredContents";
    InvalidationTag["SeasonalRecipes"] = "seasonalRecipes";
    InvalidationTag["WeeklyRecipe"] = "weeklyRecipe";
    InvalidationTag["SundayRecipes"] = "sundayRecipes";
    InvalidationTag["Family"] = "family";
    InvalidationTag["FamilyStatus"] = "familyStatus";
    InvalidationTag["Recipe"] = "recipe";
    InvalidationTag["Recipes"] = "recipes";
    InvalidationTag["Favourite"] = "favourite";
    InvalidationTag["Plan"] = "plan";
    InvalidationTag["Categories"] = "categories";
    InvalidationTag["FromWorld"] = "fromWorld";
    InvalidationTag["CalorieRange"] = "calorieRange";
    InvalidationTag["ShoppingList"] = "shoppingList";
    InvalidationTag["Notifications"] = "notifications";
    InvalidationTag["InAppPurchase"] = "inAppPurchase";
    InvalidationTag["FoodStorage"] = "foodStorage";
    InvalidationTag["CortiliaShare"] = "cortiliaShare";
    InvalidationTag["MealPrep"] = "mealPrep";
})(InvalidationTag || (InvalidationTag = {}));
export var LoaderType;
(function (LoaderType) {
    LoaderType["FullPage"] = "full-page";
    LoaderType["Contextual"] = "contextual";
    LoaderType["None"] = "none";
})(LoaderType || (LoaderType = {}));
var LOADING = 'loading';
export var useAppQuery = function (key, fetch, configs, loader) {
    if (loader === void 0) { loader = LoaderType.FullPage; }
    var dispatch = useDispatch();
    var queryObj = useQuery(key, fetch, configs);
    var loaderRef = useRef(null);
    useEffect(function () {
        if ((configs === null || configs === void 0 ? void 0 : configs.enabled) === false || loader !== LoaderType.FullPage) {
            return;
        }
        if (loaderRef.current === null && queryObj.status === LOADING) {
            var loaderId = uuid.v4();
            loaderRef.current = loaderId;
            dispatch(GeneralActions.addFullPageLoader(loaderId));
        }
        else if (loaderRef.current) {
            dispatch(GeneralActions.removeFullPageLoader(loaderRef.current));
            loaderRef.current = null;
        }
    }, [configs === null || configs === void 0 ? void 0 : configs.enabled, dispatch, loader, queryObj.status]);
    useEffect(function () {
        return function () {
            if (loaderRef.current) {
                dispatch(GeneralActions.removeFullPageLoader(loaderRef.current));
            }
        };
    }, [dispatch]);
    return queryObj;
};
export var useAppMutation = function (fetch, configs, loader) {
    if (loader === void 0) { loader = LoaderType.FullPage; }
    var dispatch = useDispatch();
    var mutation = useMutation(fetch, configs);
    var loaderRef = useRef(null);
    useEffect(function () {
        if (loader === LoaderType.FullPage) {
            if (loaderRef.current === null && mutation.status === LOADING) {
                var loaderId = uuid.v4();
                loaderRef.current = loaderId;
                dispatch(GeneralActions.addFullPageLoader(loaderId));
            }
            else if (loaderRef.current) {
                dispatch(GeneralActions.removeFullPageLoader(loaderRef.current));
                loaderRef.current = null;
            }
        }
    }, [dispatch, loader, mutation.status]);
    useEffect(function () {
        return function () {
            if (loaderRef.current) {
                dispatch(GeneralActions.removeFullPageLoader(loaderRef.current));
            }
        };
    }, [dispatch]);
    return mutation;
};
export var useAppInfiniteQuery = function (_a) {
    var key = _a.key, fetch = _a.fetch, configs = _a.configs, _b = _a.loader, loader = _b === void 0 ? LoaderType.FullPage : _b;
    var dispatch = useDispatch();
    var infiniteQueryObj = useInfiniteQuery(key, fetch, configs);
    var loaderRef = useRef(null);
    useEffect(function () {
        if (loader !== LoaderType.FullPage) {
            return;
        }
        if (loaderRef.current) {
            dispatch(GeneralActions.removeFullPageLoader(loaderRef.current));
            loaderRef.current = null;
            return;
        }
        if (!infiniteQueryObj.isFetching) {
            return;
        }
        var loaderId = uuid.v4();
        loaderRef.current = loaderId;
        dispatch(GeneralActions.addFullPageLoader(loaderId));
    }, [
        dispatch,
        loader,
        infiniteQueryObj.status,
        infiniteQueryObj.isFetchingNextPage,
        infiniteQueryObj.isFetching,
    ]);
    return infiniteQueryObj;
};
export var useClearCache = function () {
    var queryClient = useQueryClient();
    return useCallback(function () {
        queryClient.clear();
    }, [queryClient]);
};
export var invalidateQueriesForPlan = function (queryClient) {
    void queryClient.invalidateQueries({
        predicate: function (query) {
            return query.queryKey.toString().includes(InvalidationTag.Customer);
        },
        refetchType: 'active',
    });
    void queryClient.invalidateQueries({
        predicate: function (query) {
            return query.queryKey.toString().includes(InvalidationTag.Person);
        },
        refetchType: 'active',
    });
    void queryClient.invalidateQueries({
        predicate: function (query) {
            return query.queryKey.toString().includes(InvalidationTag.Family);
        },
        refetchType: 'active',
    });
    void queryClient.invalidateQueries({
        predicate: function (query) {
            return query.queryKey.toString().includes(InvalidationTag.FamilyStatus);
        },
        refetchType: 'active',
    });
    void queryClient.invalidateQueries({
        predicate: function (query) {
            return query.queryKey.toString().includes(InvalidationTag.ShoppingList);
        },
        refetchType: 'none',
    });
    void queryClient.invalidateQueries({
        predicate: function (query) {
            return query.queryKey.toString().includes(InvalidationTag.FoodStorage);
        },
        refetchType: 'active',
    });
    void queryClient.invalidateQueries({
        predicate: function (query) {
            return query.queryKey.toString().includes(InvalidationTag.FeaturedContents);
        },
        refetchType: 'all',
    });
    void queryClient.invalidateQueries({
        predicate: function (query) {
            return query.queryKey.toString().includes(InvalidationTag.WeeklyRecipe);
        },
        refetchType: 'all',
    });
    void queryClient.invalidateQueries({
        predicate: function (query) {
            return query.queryKey.toString().includes(InvalidationTag.SeasonalRecipes);
        },
        refetchType: 'all',
    });
    void queryClient.invalidateQueries({
        predicate: function (query) {
            return query.queryKey.toString().includes(InvalidationTag.SundayRecipes);
        },
        refetchType: 'all',
    });
    void queryClient.invalidateQueries({
        predicate: function (query) {
            return query.queryKey.toString().includes(InvalidationTag.Plan);
        },
        refetchType: 'none',
    });
    void queryClient.invalidateQueries({
        predicate: function (query) {
            return query.queryKey.toString().includes(InvalidationTag.MealPrep);
        },
        refetchType: 'none',
    });
};
export var invalidateAndRefetchPlanQueries = function (queryClient) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: 
            // Invalida le query del piano
            return [4 /*yield*/, queryClient.invalidateQueries({ queryKey: [InvalidationTag.Plan] })];
            case 1:
                // Invalida le query del piano
                _a.sent();
                return [4 /*yield*/, queryClient.invalidateQueries({
                        queryKey: [InvalidationTag.MealPrep],
                    })];
            case 2:
                _a.sent();
                // Forza il refetch immediato delle query del piano
                return [4 /*yield*/, queryClient.refetchQueries({ queryKey: [InvalidationTag.Plan] })];
            case 3:
                // Forza il refetch immediato delle query del piano
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
export var refreshUserDataAfterCodeRedeem = function (queryClient) { return __awaiter(void 0, void 0, void 0, function () {
    var customerQueries, customer, personQueries, person, error_1;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 4, , 5]);
                // 1. Rifetch del customer per ottenere il nuovo personId
                return [4 /*yield*/, queryClient.refetchQueries({ queryKey: [InvalidationTag.Customer] })];
            case 1:
                // 1. Rifetch del customer per ottenere il nuovo personId
                _c.sent();
                customerQueries = queryClient.getQueriesData({
                    queryKey: [InvalidationTag.Customer],
                });
                customer = (_a = customerQueries[0]) === null || _a === void 0 ? void 0 : _a[1];
                if (!(customer === null || customer === void 0 ? void 0 : customer.personId)) {
                    console.warn('Customer data not updated after code redeem');
                    return [2 /*return*/];
                }
                // 2. Rifetch della person con il nuovo personId
                return [4 /*yield*/, queryClient.refetchQueries([
                        InvalidationTag.Person,
                        { personId: customer.personId },
                    ])];
            case 2:
                // 2. Rifetch della person con il nuovo personId
                _c.sent();
                personQueries = queryClient.getQueriesData({
                    queryKey: [InvalidationTag.Person, { personId: customer.personId }],
                });
                person = (_b = personQueries[0]) === null || _b === void 0 ? void 0 : _b[1];
                if (!(person === null || person === void 0 ? void 0 : person.familyId)) {
                    console.warn('Person data not updated after code redeem');
                    return [2 /*return*/];
                }
                // 3. Rifetch della family e familyStatus con il nuovo familyId
                return [4 /*yield*/, Promise.all([
                        queryClient.refetchQueries([InvalidationTag.Family, person.familyId]),
                        queryClient.refetchQueries([
                            InvalidationTag.FamilyStatus,
                            person.familyId,
                        ]),
                    ])];
            case 3:
                // 3. Rifetch della family e familyStatus con il nuovo familyId
                _c.sent();
                console.log('User data refreshed successfully after code redeem');
                return [3 /*break*/, 5];
            case 4:
                error_1 = _c.sent();
                console.error('Error refreshing user data after code redeem:', error_1);
                throw error_1;
            case 5: return [2 /*return*/];
        }
    });
}); };
